import { render, staticRenderFns } from "./outerCompany.vue?vue&type=template&id=51ddaefc&scoped=true"
import script from "./outerCompany.vue?vue&type=script&lang=js"
export * from "./outerCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ddaefc",
  null
  
)

export default component.exports